var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "d-flex justify-content-start align-items-center",
      class: {
        start_wrapper: _vm.start_wrapper != ""
      },
      attrs: {
        "data-wrapper": _vm.start_wrapper,
        "data-json_counter": _vm.json_counter
      }
    },
    [
      _vm.json_counter > 0
        ? _c("BaseTab", { attrs: { side_border: true } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ul",
        {
          staticClass: "list-unstyled m-0 w-100",
          class: "json_counter_" + _vm.json_counter,
          attrs: { "data-item-counter": _vm.json_counter }
        },
        _vm._l(_vm.json, function(item, index, counter) {
          return _c("li", {}, [
            _c(
              "details",
              { staticClass: "json-group", attrs: { "data-counter": counter } },
              [
                _c("summary", { staticClass: "json-group--prop" }, [
                  _c("code", [
                    _vm._v(_vm._s(index) + ":\n\n                        "),
                    _vm.isObject(item)
                      ? _c("span", { staticClass: "json-group--code_open" }, [
                          _vm._v(
                            "\n                            {\n                        "
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  !_vm.isObject(item)
                    ? _c(
                        "code",
                        {
                          staticClass: "json-group--value bg-black",
                          attrs: {
                            "data-this-counter": counter,
                            "data-length": _vm.lengthObj(_vm.json)
                          }
                        },
                        [
                          _vm._v(_vm._s(item) + "\n\n                        "),
                          counter < _vm.lengthObj(_vm.json) - 1
                            ? _c("span", [_vm._v(",")])
                            : _vm._e()
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.isObject(item)
                  ? _c("BaseJsonView", {
                      staticClass: "json-group--value",
                      attrs: { json: item, json_counter: counter }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.isObject(item)
              ? _c("code", { staticClass: "json-group--code_close" }, [
                  _vm._v("},")
                ])
              : _vm._e()
          ])
        })
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-164b13b6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-164b13b6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./app/Shared/Resources/Assets/js/components/base/BaseJsonView.vue
// module id = 786
// module chunks = 0